/* tslint:disable */

declare var Object: any;
export interface TspostserviceInterface {
  "id"?: number;
}

export class Tspostservice implements TspostserviceInterface {
  "id": number;
  constructor(data?: TspostserviceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tspostservice`.
   */
  public static getModelName() {
    return "Tspostservice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tspostservice for dynamic purposes.
  **/
  public static factory(data: TspostserviceInterface): Tspostservice{
    return new Tspostservice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tspostservice',
      plural: 'Tspostservices',
      path: 'Tspostservices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tspostservice.ts